import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { CookiesProvider } from "react-cookie";
import "@fortawesome/fontawesome-free/css/all.min.css";
import App from "./App.tsx";
import store from "./redux/store";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

import "./index.css";

import * as Sentry from "@sentry/react";

function Fallback() {
  return <div>An unexpected error occurred</div>;
}

const dsn = import.meta.env.VITE_SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    tracesSampleRate: 1.0,
    sendDefaultPii: true,
    beforeBreadcrumb(breadcrumb) {
      if ((breadcrumb.category !== "fetch" && breadcrumb.category !== "xhr") || typeof breadcrumb.data?.url !== "string") {
        return breadcrumb;
      }

      try {
        const url = new URL(breadcrumb.data.url, window.location.origin);
        breadcrumb.data = { ...breadcrumb.data, url: `${url.origin}${url.pathname}` };
      } catch {
        breadcrumb.data = { ...breadcrumb.data, url: "[redacted]" };
      }
      return breadcrumb;
    },
  });
}

const renderApp = () => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <Provider store={store}>
        <CookiesProvider>
          <I18nextProvider i18n={i18n}>
            <Sentry.ErrorBoundary fallback={<Fallback />}>
              <App />
            </Sentry.ErrorBoundary>
          </I18nextProvider>
        </CookiesProvider>
      </Provider>
    </React.StrictMode>
  );
};

renderApp();
